// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"8b326602","127":"7e135e13","167":"78ba5663","415":"c614d01f","507":"b4834486","516":"2b4a25d8","639":"1eb4611d","650":"69837907","736":"23ba75a0"}[chunkId] + ".chunk.js";
};